export default __webpack_public_path__ + "static/media/successpay.9161fab1.svg";